import { AMBIENTE } from '../../enums/Ambientes';
import { PRINT } from '../../enums/Documento';

export default class ModalConfigurationData {
  id = null;

  serie = '99';

  proximaNota = '';

  idTokenCSC = '';

  tokenCSC = '';

  documento = 55;

  ambiente = AMBIENTE.HOMOLOGACAO;

  ativo = true;

  isReducedPrint = false;

  codigoAtivacao = '';

  versao = 0;

  assinatura = null;

  intermediatorNFe = false;

  intermediatorNFCe = false;

  satIdentification = '';

  constructor({
    id = null,
    serie = '99',
    proximaNota = '',
    idTokenCSC = '',
    tokenCSC = '',
    documento = 55,
    ambiente = AMBIENTE.HOMOLOGACAO,
    ativo = true,
    printType = false,
    codigoAtivacao = '',
    versao = 0,
    assinatura = null,
    intermediatorNFe = false,
    intermediatorNFCe = false,
    satIdentification = '',
  }) {
    this.id = id;
    this.serie = serie;
    this.proximaNota = proximaNota;
    this.idTokenCSC = idTokenCSC;
    this.tokenCSC = tokenCSC;
    this.documento = documento;
    this.ambiente = ambiente;
    this.ativo = ativo;
    this.isReducedPrint = printType === PRINT.REDUCED;
    this.printType = printType;
    this.codigoAtivacao = codigoAtivacao;
    this.versao = versao;
    this.assinatura = assinatura;
    this.intermediatorNFe = intermediatorNFe;
    this.intermediatorNFCe = intermediatorNFCe;
    this.satIdentification = satIdentification;
  }
}
